export default "__VITE_ASSET__Zf5XHckz__"